// extracted by mini-css-extract-plugin
module.exports = {"no":"OrdersEmptyList_no__3Lr6z"};